import { ISanityItemOption } from '@rbi-ctg/menu';

export const shouldDisplayItemOption = (() => true) as (itemOption: ISanityItemOption) => boolean;
